import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

import { IProductsCount } from '../model';

import { fifteenPx, colPct } from '.';

export const RoutineContentWrapper = styled.div<IProductsCount>`
  padding: ${fifteenPx} 0 0;
  background: ${theme.color.background.disabled};
  display: block;

  @media (min-width: ${breakpoints.md}) {
    margin-bottom: 0;
    padding-bottom: ${fifteenPx};
    display: ${(props) => (props.productsCount === 4 ? 'block' : 'flex')};
  }
`;

export const RoutineProductsWrapper = styled.div`
  overflow-x: auto;
  padding: 0 0.9375rem 1.5rem;

  @media (min-width: ${breakpoints.md}) {
    padding: 0;
  }
`;

export const RoutineProducts = styled.div<IProductsCount>`
  display: flex;
  background: ${theme.color.background.primary};
  width: fit-content;
  gap: 1rem;

  flex: ${({ productsCount }) =>
    productsCount === 4
      ? 'initial'
      : productsCount === 3
      ? `1 1 ${colPct(8)}`
      : `1 1 ${colPct(7)}`};

  padding: 0 0.5rem;

  @media (min-width: ${breakpoints.md}) {
    width: initial;
    gap: 0;
    margin: ${({ productsCount }) =>
      `${productsCount === 4 ? fifteenPx : 0} ${fifteenPx} 0`};
  }
`;
